<template>
    <div class="datatable">
        <div class="form-row"> 
            <div class="form-group col-md-10 d-flex">
                <div class="title mr-3" v-if="title">
                    {{ titleName }}
                </div> 
                <button v-for="btn in headerButtons" @click="btnHeaderAction(btn.action)" :class="btn.classe">
                    <i :class="btn.iconClass" v-if="btn.iconClass"></i>
                    {{ btn.value }}
                </button>
                <slot></slot>
            </div>
            <div class="form-group col-md-2">
                <input 
                    type="text" 
                    class="form-control float-right form-control-sm" 
                    v-model="search" 
                    placeholder="Pesquisar..." 
                    v-if="doSearch">
            </div>
        </div>
        <table 
            class="table table-bordered table-striped" 
            style="overflow-x:auto;" 
            id="table" 
            v-if="total >= 0">
            <thead>
                <tr>
                    <th v-for="column in columns"
                        :key="column.field"
                        class="th-sm"
                        v-on:click="setSort(column)"
                        :class="{ 
                            active: column.field == thActive.field,
                            sorting: !column.noSorting
                        }">
                        {{column.label}} 
                        <i v-if="sorting && !column.noSorting" class="fas fa-sort float-right noprint"></i>    
                    </th>
                    <th v-if="actionFild" class="noprint" width="20">Ações</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in rows" v-if="total > 0">
                    <td v-for="column in columns" v-if="row[column.field]" @click="selectRow(row)">
                        <div v-html="row[column.field]"></div>
                    </td>
                    <td v-else>-</td>
                    <td v-if="actionFild" class="d-flex justify-content-between noprint">
                        <div class="btn-group noprint" role="group" aria-label="Basic example">
                            <template v-for="(btn, index) in buttons">
                                <button 
                                    v-if="isBtnVisible(btn, row)"
                                    :key="index"
                                    @click.stop="btnAction(btn.action, row)" 
                                    :class="getBtnClasse(btn, row)"
                                    :title="getBtnTitle(btn, row)">
                                    <i :class="getBtnIconClass(btn, row)" v-if="getBtnIconClass(btn, row)"></i>
                                    <span v-if="getBtnValue(btn, row)">{{ getBtnValue(btn, row) }}</span>
                                </button>
                            </template>
                        </div>
                    </td>
                </tr>
                <tr v-if="total === 0">
                    <td :colspan="columns.length + 1" v-if="actionFild">
                        Nenhum resultado encontrado.
                    </td>
                    <td :colspan="columns.length" v-else>
                        Nenhum resultado encontrado.
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="alert alert-primary" v-else>
            <bsh-load-circle></bsh-load-circle>
        </div>
        <!-- Paginação -->
        <bsh-paginate
            :source="pagination" 
            @clickNav="getDados">  
        </bsh-paginate> 
    </div>
</template>

<script>
import bshMessage from './../messages/message.js';
export default {
    props: {
        columns: {
            type: Array
        },
        actionFild: {
            type: Boolean,
            default: false
        }, 
        sorting: {
            type: Boolean,
            default: true
        },
        doSearch: {
            type: Boolean,
            default: true
        },
        link: {
            type: String,
        },
        headerButtons: {
            type: Array
        },
        buttons: {
            type: Array
        },
        title: {
            type: Boolean,
            default: false
        },
        titleName: {
            type: String,
        },
        titleClass: {
            type: String,
        }
    },
    
    data() {
        return {
            rows: [],
            total: -1,
            pagination: {},
            thActive: '',
            sort: 'asc',
            page: 1,
            search: '',
            searchQueryIsDirty: false,
            isCalculating: false
        }
    },

    created(){
        this.thActive = this.columns[0];
        this.getDados();
    },

    computed: {
        // filter objects by parameters match
        filteredRows() {
          return this.rowsDisplay.filter(row => {
            return row.filter(value => value
              .toString()
              .toLowerCase()
              .match(this.search.toLowerCase()))
              .length > 0;
          });
        }
    },
    methods: {
        getDados(page=''){
            this.total = -1;

            axios.get(this.getComplexLink(page))
            .then(response => {
                this.rows = response.data.data.data
                this.total = response.data.data.total
                this.pagination = response.data.data
                this.setFields()
            })
            .catch(error => {
                bshMessage.show('Ocorreu um erro ao carregar a tabela.', 'error')
            });
        },
        setFields(){
            for(var i = 0; i<this.columns.length; i++){
                let fields = this.columns[i]['field'].split(".");
                if(fields.length > 1){
                    for(var x = 0; x<this.rows.length; x++){
                        let value = this.rows[x];
                        for(var j = 0; j<fields.length; j++){
                            if(value[fields[j]] != null){
                                value = value[fields[j]];
                            } else {
                                value = null;
                                break;
                            }
                        }
                        this.rows[x][this.columns[i]['field']] = value;
                    }
                }
            }
        },
        getComplexLink(page){
            var complexLink = '';
            if(this.link.indexOf("?") == -1){
                complexLink = this.link+'?page='+page;
            } else {
                complexLink = this.link+'&page='+page;
            }

            if(!this.thActive.noSorting){
                if(this.thActive.order){
                    complexLink += '&order='+this.thActive.order+'&sort='+this.sort
                } else {
                    complexLink += '&order='+this.thActive.field+'&sort='+this.sort
                }
            }
            if(this.search){
                complexLink += '&pesquisa='+this.search;
            }
            return complexLink;
        },
        setSort(column){
            if(this.sorting && !column.noSorting){
                if(this.thActive == column){
                    if(this.sort == 'asc'){
                        this.sort = 'desc';
                    } else {
                        this.sort = 'asc';
                    }
                } else {
                    this.thActive = column;
                }
                this.getDados(this.page);
            }
        },
        expensiveOperation: _.debounce(function () {
            this.isCalculating = true
            setTimeout(function () {
                this.isCalculating = false
                this.searchQueryIsDirty = false
            }.bind(this), 1000)
        }, 500),
        selectRow(row) {
            this.$emit('selectRow',row);
        },
        btnAction(action, row){
            this.$emit(action, row);
        },
        isBtnVisible(btn, row) {
            if (typeof btn.visible === 'function') {
                return btn.visible(row);
            }
            if (btn.visible !== undefined) {
                return !!btn.visible;
            }
            return true;
        },
        getBtnClasse(btn, row) {
            if (typeof btn.classe === 'function') {
                return btn.classe(row);
            }
            return btn.classe;
        },
        getBtnIconClass(btn, row) {
            if (typeof btn.iconClass === 'function') {
                return btn.iconClass(row);
            }
            return btn.iconClass;
        },
        getBtnValue(btn, row) {
            if (typeof btn.value === 'function') {
                return btn.value(row);
            }
            return btn.value;
        },
        getBtnTitle(btn, row) {
            if (typeof btn.title === 'function') {
                return btn.title(row);
            }
            return btn.title;
        },
        btnHeaderAction(action){
            this.$emit(action);
        },
    },
    watch: {
        search: function () {
            this.searchQueryIsDirty = true
            this.expensiveOperation()
        },
        isCalculating: function () {
            if(this.isCalculating){
                this.getDados()
            }
        },
        data(newVal) {
          this.columns = newVal.columns;
        },
        rows(){
          //this.filterArray();
        },
    }
}
</script>

<style scoped>
    th {
        cursor: pointer;
        color: #585858;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    td {
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    th:hover {
        background-color: #D8D8D8;
    }
    tbody tr:hover {
        background-color: #D8D8D8;
    }
    .title {
        font-size: 18px;
        color: #585858;
    }
    .active {
        background-color: #F2F2F2;
    }
    .cl-white {
        color: white;
    }
    .btn-verde {
        background-color: transparent;
        color: #3490dc;
        font-size: 16px;
    }
    .btn-amarelo {
        background-color: transparent;
        color: #3490dc;
        font-size: 16px;
    }
    .btn-vermelho {
        background-color: transparent;
        color: #e3342f;
        font-size: 16px;
    } 

    @media print { 
        .noprint, .noprint *
        {
            display: none !important;
        }
    }

    @media only screen and (max-width: 1200px) {
        .datatable {
            overflow: auto;
        }
    }
</style>
